import { Controller } from "@hotwired/stimulus";

// Радио-чипы: переключает визуальные классы label в зависимости от checked.
// Использование:
//   <div data-controller="chip-radio">
//     <label data-chip-radio-target="chip" data-value="electricity" data-active-class="bg-blue-600 border-blue-600 text-white" data-inactive-class="bg-white border-gray-300 text-gray-700">...</label>
//     <input type="radio" name="outage[kind]" value="electricity" data-action="change->chip-radio#update">
//   </div>
export default class extends Controller {
  static targets = ["chip"];

  connect() {
    this.update();
  }

  update() {
    const groupName = this.element.querySelector('input[type="radio"]')?.name;
    if (!groupName) return;

    const checkedValue = this.element.querySelector(`input[type="radio"][name="${CSS.escape(groupName)}"]:checked`)?.value;

    this.chipTargets.forEach((chip) => {
      const active = chip.dataset.value === checkedValue;
      const activeClasses = chip.dataset.activeClass?.split(/\s+/) || [];
      const inactiveClasses = chip.dataset.inactiveClass?.split(/\s+/) || [];

      if (active) {
        chip.classList.remove(...inactiveClasses);
        chip.classList.add(...activeClasses);
      } else {
        chip.classList.remove(...activeClasses);
        chip.classList.add(...inactiveClasses);
      }
    });
  }
}
